// extracted by mini-css-extract-plugin
export default {"table_container":"jobRolesTable_table_container__40Ap7","table-row":"jobRolesTable_table-row__OG6JU","AddroleButton":"jobRolesTable_AddroleButton__y9YZT"};